/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback} from 'react'

import {TRACK_EVENTS, TRACK_PAGE_EVENTS} from './config.js'
import {useCriteoData} from './useCriteoData.js'

const useCriteoTrack = () => {
  const {getCriteoData} = useCriteoData()

  const _onDispatchTrack = () =>
    useCallback(async ({event, eventData}) => {
      const {criteoData} = await getCriteoData({event, eventData})

      window.criteo_q = window.criteo_q || []
      window.criteo_q.push(...criteoData)
    }, [])

  return {track: _onDispatchTrack()}
}

export {TRACK_EVENTS as criteoTrackEvents, TRACK_PAGE_EVENTS as criteoTrackPageEvents}

export default useCriteoTrack
